import type { GetAdminV1StoresStoreIdInventoryMovementsParams } from '@nucleus-commerce/api-client/admin';

import { productKeys } from '@/features/products';

import type { InventoryListParams } from '../api/inventory-api';

/** Store-scoped keys: switching stores never shares cache. */
export const inventoryKeys = {
  all: (storeId: string) => ['stores', storeId, 'inventory'] as const,
  locations: (storeId: string) => [...inventoryKeys.all(storeId), 'locations'] as const,
  levels: (storeId: string) => [...inventoryKeys.all(storeId), 'levels'] as const,
  levelList: (storeId: string, params: InventoryListParams) =>
    [...inventoryKeys.levels(storeId), params] as const,
  /** Under levels, so every stock change refreshes the variant page too. */
  item: (storeId: string, variantId: string) =>
    [...inventoryKeys.levels(storeId), 'item', variantId] as const,
  movements: (storeId: string) => [...inventoryKeys.all(storeId), 'movements'] as const,
  movementList: (
    storeId: string,
    params: Omit<GetAdminV1StoresStoreIdInventoryMovementsParams, 'cursor'>,
  ) => [...inventoryKeys.movements(storeId), params] as const,
};

/** Organization-level, under the master product: its stock in every store the member sees. */
export const productStockKey = (productId: string) =>
  [...productKeys.detail(productId), 'stock'] as const;
